/**
 * @author       matthew@zumper.com (Matthew Talamini)
 * @copyright    Copyright (c) 2021, Zumper
 * @description  PriceChart constants index -- refer to nzr PriceChart module
 */

export * from './schoolWidget'

// fetching
export const DONE_FETCHING_CITY_PRICE_CHART_DATA =
  '@@nzr/priceChart/locale/DONE_FETCHING_CITY_PRICE_CHART_DATA'
export const DONE_FETCHING_HOOD_PRICE_CHART_DATA =
  '@@nzr/priceChart/locale/DONE_FETCHING_HOOD_PRICE_CHART_DATA'
export const ERROR_FETCHING_CITY_PRICE_CHART_DATA =
  '@@nzr/priceChart/locale/ERROR_FETCHING_CITY_PRICE_CHART_DATA'

export const ERROR_FETCHING_HOOD_PRICE_CHART_DATA =
  '@@nzr/priceChart/locale/ERROR_FETCHING_HOOD_PRICE_CHART_DATA'
export const START_FETCHING_CITY_PRICE_CHART_DATA =
  '@@nzr/priceChart/locale/START_FETCHING_CITY_PRICE_CHART_DATA'
export const START_FETCHING_HOOD_PRICE_CHART_DATA =
  '@@nzr/priceChart/locale/START_FETCHING_HOOD_PRICE_CHART_DATA'

// storing
export const CLEAR_PRICE_CHART_DATA = '@@nzr/priceChart/locale/CLEAR_PRICE_CHART_DATA'
export const CLEAR_HOOD_PRICE_CHART_DATA = '@@nzr/priceChart/locale/CLEAR_HOOD_PRICE_CHART_DATA'
export const SET_CITY_PRICE_CHART_DATA = '@@nzr/priceChart/locale/SET_CITY_PRICE_CHART_DATA'
export const SET_HOOD_PRICE_CHART_DATA = '@@nzr/priceChart/locale/SET_HOOD_PRICE_CHART_DATA'
